var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "@drklein/client-detection", "@drklein/locale-formatter", "jquery", "./FormElementValidation", "jquery", "jquery-ui/ui/i18n/datepicker-de", "jquery-ui/ui/widgets/datepicker"], function (require, exports, client_detection_1, LocaleFormatter, $, FormElementValidation) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.bootstrapFormElement = exports.checkFormValidity = exports.initializeFormElementFields = exports.initializeForms = exports.scrollToFirstInvalidFormElement = exports.convertStringToDate = exports.getFormElementField = exports.isSelectTag = exports.isDatepickerInput = exports.isEuroField = exports.isUnitField = exports.formatInputFieldValue = exports.formElementFieldInvalidClass = exports.formElementFieldSelector = exports.inputFieldSelector = exports.formElementValidateSelector = exports.formElementValidateClass = void 0;
    LocaleFormatter = __importStar(LocaleFormatter);
    FormElementValidation = __importStar(FormElementValidation);
    var formElementSelector = ".formElement";
    exports.formElementValidateClass = "formElement-validate";
    exports.formElementValidateSelector = "." + exports.formElementValidateClass;
    exports.inputFieldSelector = ":input";
    exports.formElementFieldSelector = ".formElement_field";
    exports.formElementFieldInvalidClass = "formElement_field--is-invalid";
    /**
     * Formatiert den Wert eines Eingabefelds, indem nur Ziffern und der Teil vor dem ersten Komma behalten werden
     * @param {any} fieldValue - Der zu formatierende Wert
     * @returns {string} Der formatierte Wert
     */
    function formatInputFieldValue(fieldValue) {
        return keepOnlyDigits(keepOnlyPartLeftOfFirstComma(fieldValue));
    }
    exports.formatInputFieldValue = formatInputFieldValue;
    /**
     * Prüft, ob es sich um ein Einheitenfeld handelt
     * @param {JQuery} $element - Das zu prüfende jQuery-Element
     * @returns {boolean} True, wenn es sich um ein Einheitenfeld handelt
     */
    function isUnitField($element) {
        return $element.data("unit-field") === true;
    }
    exports.isUnitField = isUnitField;
    /**
     * Prüft, ob es sich um ein Euro-Feld handelt
     * @param {JQuery} $element - Das zu prüfende jQuery-Element
     * @returns {boolean} True, wenn es sich um ein Euro-Feld handelt
     */
    function isEuroField($element) {
        return $element.parents(".formElement").hasClass("formElement-euro");
    }
    exports.isEuroField = isEuroField;
    /**
     * Prüft, ob es sich um ein Datepicker-Eingabefeld handelt
     * @param {JQuery} $element - Das zu prüfende jQuery-Element
     * @returns {boolean} True, wenn es sich um ein Datepicker-Eingabefeld handelt
     */
    function isDatepickerInput($element) {
        return $element.data("datepicker") === true;
    }
    exports.isDatepickerInput = isDatepickerInput;
    /**
     * Prüft, ob es sich um ein Select-Element handelt
     * @param {JQuery} $element - Das zu prüfende jQuery-Element
     * @returns {boolean} True, wenn es sich um ein Select-Element handelt
     */
    function isSelectTag($element) {
        return $element.prop("tagName") === "SELECT";
    }
    exports.isSelectTag = isSelectTag;
    /**
     * Gibt das übergeordnete FormElement-Feld eines Eingabefelds zurück
     * @param {JQuery<HTMLInputElement>} $inputField - Das Eingabefeld
     * @returns {JQuery} Das übergeordnete FormElement-Feld
     */
    function getFormElementField($inputField) {
        return $inputField.closest(exports.formElementFieldSelector);
    }
    exports.getFormElementField = getFormElementField;
    /**
     * Konvertiert einen Datumsstring in ein Date-Objekt
     * @param {string} dateString - Der zu konvertierende Datumsstring im Format "dd.mm.yyyy"
     * @returns {Date} Das konvertierte Date-Objekt
     */
    function convertStringToDate(dateString) {
        var dateArray = dateString.split(".");
        if (dateArray.length === 3) {
            return new Date("".concat(dateArray[2], "-").concat(reformatWithAtLeastTwoDigits(dateArray[1]), "-").concat(reformatWithAtLeastTwoDigits(dateArray[0])));
        }
        return new Date(dateString);
    }
    exports.convertStringToDate = convertStringToDate;
    /**
     * Scrollt zum ersten ungültigen FormElement
     * @param {JQuery} $form - Das Formular, in dem gesucht werden soll
     */
    function scrollToFirstInvalidFormElement($form) {
        var $firstInvalidField = $form.find(".formElement_field--is-invalid:visible").first();
        if ($firstInvalidField.length === 1) {
            var $container = $firstInvalidField.closest(".formElement:visible");
            var $scrollTarget = $container.length ? $container : $firstInvalidField;
            var offset = $scrollTarget.offset();
            if (offset && typeof offset.top === "number" && offset.top > 0) {
                window.scrollTo(0, offset.top - 80);
            }
        }
    }
    exports.scrollToFirstInvalidFormElement = scrollToFirstInvalidFormElement;
    /**
     * Formatiert einen String mit mindestens zwei Ziffern
     * @param {string} stringValue - Der zu formatierende String
     * @returns {string} Der formatierte String mit mindestens zwei Ziffern
     */
    function reformatWithAtLeastTwoDigits(stringValue) {
        return stringValue.length === 1 ? "0" + stringValue : stringValue;
    }
    /**
     * Extrahiert den Teil eines Strings vor dem ersten Komma
     * @param {string} input - Der Eingabestring
     * @returns {string} Der Teil des Strings vor dem ersten Komma
     */
    function keepOnlyPartLeftOfFirstComma(input) {
        return input.split(",")[0];
    }
    /**
     * Entfernt alle nicht-numerischen Zeichen aus einem String
     * @param {string} input - Der Eingabestring
     * @returns {string} Der String ohne nicht-numerische Zeichen
     */
    function keepOnlyDigits(input) {
        return input.replace(/\D/g, "");
    }
    /**
     * Prüft, ob es sich um ein PLZ-Feld handelt
     * @param {JQuery} $element - Das zu prüfende jQuery-Element
     * @returns {boolean} True, wenn es sich um ein PLZ-Feld handelt
     */
    function isPlzField($element) {
        return $element.data("plz-field") === true;
    }
    /**
     * Prüft, ob es sich um ein Datumseingabefeld handelt
     * @param {JQuery} $element - Das zu prüfende jQuery-Element
     * @returns {boolean} True, wenn es sich um ein Datumseingabefeld handelt
     */
    function isDateInput($element) {
        return $element.attr("type") === "date";
    }
    /**
     * Prüft, ob es sich um ein URL-Eingabefeld handelt
     * @param {JQuery} $element - Das zu prüfende jQuery-Element
     * @returns {boolean} True, wenn es sich um ein URL-Eingabefeld handelt
     */
    function isUrlInput($element) {
        return $element.attr("type") === "url";
    }
    /**
     * Prüft, ob ein Element validiert werden soll
     * @param {JQuery} $element - Das zu prüfende jQuery-Element
     * @returns {boolean} True, wenn das Element validiert werden soll
     */
    function isToValidate($element) {
        return $element.closest(formElementSelector).hasClass(exports.formElementValidateClass);
    }
    /**
     * Formatiert einen Wert mit Einheit
     * @param {any} value - Der zu formatierende Wert
     * @param {string} unit - Die Einheit
     * @param {any} configuration - Die Konfiguration für die Formatierung
     * @returns {string} Der formatierte Wert mit Einheit
     */
    function formatAsUnit(value, unit, configuration) {
        var formattedValue = formatInputFieldValue(value);
        if (formattedValue === "") {
            return "";
        }
        if (configuration.unitPosition === "number") {
            return LocaleFormatter.unit(formattedValue, unit);
        }
        return LocaleFormatter.numberWithThousandsSeparator(formattedValue, 0);
    }
    /**
     * Formatiert einen Wert als PLZ
     * @param {any} value - Der zu formatierende Wert
     * @returns {string} Der formatierte PLZ-Wert
     */
    function formatAsPlz(value) {
        return keepOnlyDigits(value);
    }
    /**
     * Formatiert einen Wert als URL
     * @param {any} value - Der zu formatierende Wert
     * @returns {string} Die formatierte URL
     */
    function formatAsUrl(value) {
        var url = "";
        if (typeof value === "string") {
            url = value.trim();
            if (url.length > 0 && url.indexOf("http") !== 0) {
                url = "http://" + url;
            }
        }
        return url;
    }
    /**
     * Fügt einen Blur-Handler hinzu und führt ihn aus
     * @param {Function} callableFunction - Die auszuführende Funktion
     * @param {JQuery} $element - Das jQuery-Element
     */
    function addAndCallOnBlurHandler(callableFunction, $element) {
        var onBlur = function () {
            $element.val(callableFunction($element.val()));
            $element.trigger("hypoport.formElement.blurFinished", []);
        };
        $element.blur(onBlur);
        onBlur();
    }
    /**
     * Fügt einen Validierungs-Handler für Änderungen hinzu
     * @param {JQuery<HTMLInputElement>} $inputField - Das Eingabefeld
     */
    function addValidityOnChangeHandler($inputField) {
        $inputField.on("change", function () {
            FormElementValidation.handleFormElementValidation(getFormElementField($inputField));
        });
    }
    /**
     * Fügt einen Handler für die Aktualisierung des Elementwerts bei Änderungen hinzu
     * @param {Function} callableFunction - Die auszuführende Funktion
     * @param {JQuery} $element - Das jQuery-Element
     */
    function addUpdateElementValueOnChangeHandler(callableFunction, $element) {
        $element.change(function () {
            $element.val(callableFunction($element.val()));
        });
    }
    /**
     * Fügt Event-Handler zu einem Feld hinzu
     * @param {HTMLElement} field - Das zu konfigurierende Feld
     * @param {IFormElementConfiguration} formElementConfiguration - Die Konfiguration für das FormElement
     */
    function addEventHandlersToField(field, formElementConfiguration) {
        var _a, _b;
        var $field = $(field);
        if (isUnitField($field)) {
            addAndCallOnBlurHandler(function (value) {
                return formatAsUnit(value, $field.data("unit"), formElementConfiguration);
            }, $field);
        }
        else if (isEuroField($field)) {
            addAndCallOnBlurHandler(function (value) {
                return formatAsUnit(value, "€", formElementConfiguration);
            }, $field);
        }
        else if (isPlzField($field)) {
            addAndCallOnBlurHandler(formatAsPlz, $field);
        }
        else if (isDateInput($field)) {
            initializeJQueryDatepicker($field);
        }
        else if (isUrlInput($field)) {
            addUpdateElementValueOnChangeHandler(formatAsUrl, $field);
        }
        if (isToValidate($field)) {
            addValidityOnChangeHandler($field);
        }
        if ($field.hasClass("fill-icon")) {
            var placeholder = (_a = $field.attr("placeholder")) !== null && _a !== void 0 ? _a : " ";
            var html_calc = $("<span>", { class: "input", html: placeholder });
            html_calc.appendTo($("body"));
            var width = (_b = html_calc.width()) !== null && _b !== void 0 ? _b : 0;
            if (width > 0) {
                $field.css("background-position-x", width / 16 + 1 + "rem");
            }
            html_calc.remove();
        }
        if ($field.attr("placeholder")) {
            $field
                .on("focus", function () {
                var _a;
                var placeholder = (_a = $field.attr("placeholder")) !== null && _a !== void 0 ? _a : " ";
                if (isEuroField($field)) {
                    $(this).data("placeholder", placeholder).attr("placeholder", "_ €").removeClass("fill-icon");
                }
                else {
                    $(this).data("placeholder", placeholder).attr("placeholder", "_").removeClass("fill-icon");
                }
            })
                .on("blur", function () {
                var _a;
                var placeholder = $field.data("placeholder");
                var value = (_a = $(this).val()) !== null && _a !== void 0 ? _a : "";
                if (value === "") {
                    $(this).attr("placeholder", placeholder).addClass("fill-icon");
                }
            });
        }
    }
    /**
     * Fügt einen Submit-Handler zum Formular hinzu
     * @param {JQuery} $form - Das Formular
     */
    function addFormOnSubmitHandler($form) {
        $form.on("submit", function () {
            $form
                .find(exports.inputFieldSelector)
                .filter(function (index, inputField) {
                return isUnitField($(inputField));
            })
                .each(function (index, unitField) {
                var $unitField = $(unitField);
                $unitField.val(formatInputFieldValue($unitField.val()));
            });
        });
    }
    /**
     * Initialisiert den jQuery Datepicker für ein Feld
     * @param {JQuery<HTMLInputElement>} $field - Das zu initialisierende Feld
     */
    function initializeJQueryDatepicker($field) {
        if (!client_detection_1.MobileDetection.isMobile()) {
            var $fieldFirst_1 = $field.get(0) || null;
            if ($fieldFirst_1 !== null) {
                $field.attr("type", "text");
                $field.attr("data-datepicker", "true");
                $field.attr("pattern", "(0?[1-9]|1[0-9]|2[0-9]|3[01]).(0?[1-9]|1[012]).[12][0-9]{3}");
                $field.attr("placeholder", "tt.mm.jjjj");
                var min = new Date($field.attr("min") || "");
                var max = new Date($field.attr("max") || "");
                var defaultDate = $field.attr("data-default-date") || "";
                var datepickerOptions = {
                    showAnim: "slideDown",
                    showButtonPanel: true,
                    dateFormat: "dd.mm.yy",
                    constrainInput: true,
                    buttonText: "",
                    showOn: "button",
                    minDate: min,
                    maxDate: max,
                    defaultDate: defaultDate,
                    changeYear: true,
                    beforeShow: function () {
                        $fieldFirst_1.disabled = true;
                        return $field.datepicker("option");
                    },
                    onClose: function () {
                        $fieldFirst_1.disabled = false;
                        $field.triggerHandler("change");
                    },
                };
                $field.datepicker(datepickerOptions);
                $field.datepicker($.datepicker.regional["de"]);
                $field.datepicker("setDate", new Date());
                var setAriaLabel_1 = function (retries, delay) {
                    if (retries === void 0) { retries = 10; }
                    if (delay === void 0) { delay = 100; }
                    var $trigger = $(".ui-datepicker-trigger");
                    if ($trigger.length > 0) {
                        $trigger.attr("aria-label", "Datum auswählen");
                    }
                    else if (retries > 0) {
                        setTimeout(function () { return setAriaLabel_1(retries - 1, delay); }, delay);
                    }
                };
                setAriaLabel_1();
            }
        }
    }
    /**
     * Initialisiert die Formulare
     * @param {JQuery<HTMLFormElement>} $forms - Die zu initialisierenden Formulare
     */
    function initializeForms($forms) {
        $forms.each(function (index, form) {
            var $form = $(form);
            var formFirst = $form.get(0) || null;
            if (formFirst !== null) {
                $form.attr("novalidate", "novalidate");
                if (formFirst.hasAttribute("data-isFormElementInitialized")) {
                    addFormOnSubmitHandler($form);
                    FormElementValidation.handleFormInvalidation(form);
                    formFirst.setAttribute("data-isFormElementInitialized", "true");
                }
            }
        });
    }
    exports.initializeForms = initializeForms;
    /**
     * Initialisiert die FormElement-Felder
     * @param {JQuery<HTMLElement>} $formElementFields - Die zu initialisierenden FormElement-Felder
     * @param {IFormElementConfiguration} formElementConfiguration - Die Konfiguration für die FormElement-Felder
     */
    function initializeFormElementFields($formElementFields, formElementConfiguration) {
        $formElementFields.find(exports.inputFieldSelector).each(function (index, field) {
            var parent = $(field).parent().get(0) || null;
            if (parent !== null) {
                var parentFormElement = $(field).parents(".formElement").get(0) || null;
                if (parentFormElement !== null) {
                    if (($(parent).hasClass("formElement_field-date") ||
                        $(parent).hasClass("formElement_field-email") ||
                        $(parent).hasClass("formElement_field-select") ||
                        $(parent).hasClass("formElement_field-singleselect") ||
                        $(parent).hasClass("formElement_field-text") ||
                        $(parent).hasClass("formElement_field-textarea") ||
                        $(parent).hasClass("formElement_field-tel") ||
                        $(parent).hasClass("formElement_field-telephone") ||
                        $(parent).hasClass("formElement_field-input-unit") ||
                        $(parent).hasClass("inputs-list")) &&
                        !$(parentFormElement).hasClass("formElement-outside")) {
                        $(parentFormElement).addClass("formElement-inside");
                    }
                }
                if ($(parent).hasClass("formElement_field-select") || $(parent).hasClass("formElement_field-singleselect")) {
                    $(field).on("change", function () {
                        $(this).trigger("blur");
                    });
                }
                if ($(parent).hasClass("formElement_field-hidden")) {
                    var formElemementHidden = $(field).parents(".formElement").get(0) || null;
                    if (formElemementHidden !== null) {
                        $(formElemementHidden).addClass("formElement-hidden");
                    }
                }
                addEventHandlersToField(field, formElementConfiguration);
            }
        });
    }
    exports.initializeFormElementFields = initializeFormElementFields;
    /**
     * Prüft die Gültigkeit eines Formulars
     * @param {JQuery<HTMLFormElement>} $form - Das zu prüfende Formular
     * @returns {boolean} True, wenn das Formular gültig ist
     */
    function checkFormValidity($form) {
        return FormElementValidation.checkFormValidity($form);
    }
    exports.checkFormValidity = checkFormValidity;
    /**
     * Initialisiert die FormElement-Komponente
     * @param {any} querySelectorElement - Das Element, in dem die FormElement-Komponente initialisiert werden soll
     * @param {IFormElementConfiguration} formElementConfiguration - Die Konfiguration für die FormElement-Komponente
     */
    function bootstrapFormElement(querySelectorElement, formElementConfiguration) {
        var $querySelectorElement = $(querySelectorElement);
        initializeFormElementFields($querySelectorElement.find(exports.formElementFieldSelector), formElementConfiguration);
        initializeForms($querySelectorElement.find("form"));
    }
    exports.bootstrapFormElement = bootstrapFormElement;
    exports.default = {
        inputFieldSelector: exports.inputFieldSelector,
        formElementValidateClass: exports.formElementValidateClass,
        formElementValidateSelector: exports.formElementValidateSelector,
        formElementFieldSelector: exports.formElementFieldSelector,
        formElementFieldInvalidClass: exports.formElementFieldInvalidClass,
        formatInputFieldValue: formatInputFieldValue,
        isUnitField: isUnitField,
        isDatepickerInput: isDatepickerInput,
        isSelectTag: isSelectTag,
        getFormElementField: getFormElementField,
        convertStringToDate: convertStringToDate,
        scrollToFirstInvalidFormElement: scrollToFirstInvalidFormElement,
        initializeForms: initializeForms,
        initializeFormElementFields: initializeFormElementFields,
        checkFormValidity: checkFormValidity,
        bootstrapFormElement: bootstrapFormElement,
    };
    $(function () {
        bootstrapFormElement("body", { unitPosition: "number" });
    });
});
